// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__18Yfl","legacyBtn":"MutateMid_legacyBtn__2sinb"};